import styled from 'styled-components';
import { Image, Container, HeaderPages } from '../components';
import { Para, Head_3, Button } from '../components/Typography';
import '../animation/boundInUp.css';

const About = () => {
  return (
    <>
      <div>
        <Container>
          <Column_1 className="animate__animated animate__zoomIn">
            <Image src={'/images/about_elham.PNG'} alt="about_elham" />
          </Column_1>
          <Column_2 className="animate__boundInUp">
            <Wrapper_Text>
              <HeaderPages title="About Me" shadow={'Me'} />
              <Head_3>Full Stack Developer</Head_3>
              <Para>
                I am a geek enthusiastic developer, who is passionate and eager to keep track of the
                latest web technologies. I have experience in building responsive and modern web
                applications using JavaScript in the front-end(React) and in the back-end(Node) in
                addition to other skills like testing, debugging, and deploying websites.
              </Para>
              <Button to="/" width="16rem">
                Download Resume
              </Button>
            </Wrapper_Text>
          </Column_2>
        </Container>
      </div>
    </>
  );
};
export default About;

//-- needed refactor
const Column_1 = styled.div`
  flex: 5;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  &.animate__animated {
    animation-delay: 1s;
    animation-duration: 1s;
  }
`;
const Column_2 = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 8;
  display: flex;
  justify-content: center;
`;
const Wrapper_Text = styled.div`
  min-height: 60%;
  max-width: 78%;
  padding-left: 6%;
`;
